export default [
  {
    path: "/game/gameRank",
    component: () => import("@views/game/GameRank"),
    meta: { title: "成绩排名" },
  },
  {
    path: "/game/handWriteSign",
    component: () => import("@views/game/handWriteSign/index"),
    meta: { title: "手写签到" },
  },
  {
    path: "/game/cashCount",
    component: () => import("@views/game/cashCount/index"),
    meta: { title: "数钱啦" },
  },
  {
    path: "/game/goldenEgg",
    component: () => import("@views/game/goldenEgg/index"),
    meta: { title: "砸金蛋" },
  },
  {
    path: "/game/firework",
    component: () => import("@views/game/fireworkGame/index"),
    meta: { title: "放火箭" },
  },
  {
    path: "/game/redPacketRain",
    component: () => import("@views/game/redPacketRain/index"),
    meta: { title: "抢红包" },
  },
  {
    path: "/game/shake",
    component: () => import("@views/game/shake/index"),
    meta: { title: "摇一摇" },
  },
];
